'use client'

import { Badge, Icon } from '@vinted/web-ui'
import { IconType } from '@vinted/web-ui/dist/types/lib/Icon/Icon'

type Props = {
  id: string
  iconType: IconType
  content: string | null
  isVisible: boolean
}

const DiscountBadge = ({ id, iconType, content, isVisible }: Props) =>
  isVisible && (
    <Badge
      testId={`${id}-discount-badge`}
      theme="warning"
      styling={Badge.Styling.Filled}
      icon={
        <Icon
          name={iconType}
          color={Icon.Color.GreyscaleLevel6}
          aria={{
            'aria-hidden': 'true',
          }}
        />
      }
      content={content}
    />
  )

export default DiscountBadge
